
const Employment = props =>{
    return (props.data.map(job=>{
            if (job.roles){
                var details = job.roles.map( role => {
                    return <>
                            <div className="empSubHeading" style={{color:'#605f5f'}}>&#128898; &nbsp; &nbsp; <strong><i>{role.title}</i></strong></div>
                            <div className="empSubHeading empDates" style={{color:'#464646', fontSize: 'smaller'}}><i>{role.start} - {role.end}</i></div>
                            <div style={{ whiteSpace: 'pre-wrap' }}>{role.description}</div>    {/*use pre-wrap to preserve line breaks*/}
                                <ul className="empList">
                                    {role.highlights.map( (highlight, idx)=>{
                                        return <li key={role.id + idx}>{highlight}</li>
                                    })}
                                </ul>
                        </>
                        })
            }else{
                details = 
                <>
                    <div>{job.description}</div>
                    <ul className="empList">
                        {job.highlights.map( (highlight, idx)=>{
                            return <li key={job.id + idx}>{highlight}</li>
                        })}
                    </ul>
                </>
            }
            
            return <div className="jobWrapper" key={job.id}>
                <div className="empSubHeading"><strong>{job.title}</strong> - {job.company}</div>
                <div className="empSubHeading empDates"><i>{job.start} - {job.end}</i></div>
                <br/>
                {/* <div>{job.description}</div>
                <ul className="empList">
                    {job.highlights.map( (highlight, idx)=>{
                        return <li key={job.id + idx}>{highlight}</li>
                    })}
                </ul> */}
                {details}
            </div>
        })
    )
    
}

export default Employment;